import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { FlatList, Image, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { Typography } from '../typography/Typography';
import Icon from '../icon/Icon';
import { UPDATE_REQUEST_TYPE } from '../pages/constants';
const PendingUnpledgeView = ({ viewAction, isList, triggerAction, actionList }) => {
    const getUrlImage = (type, title) => {
        let url = '';
        if (type === UPDATE_REQUEST_TYPE.PHONE_NUMBER || type === UPDATE_REQUEST_TYPE.EMAIL) {
            if (title?.includes('failed')) {
                url = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Status.png';
            }
            else
                url = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Inprogress_icon.png';
        }
        else
            url = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/rupee_aura.png';
        return url;
    };
    const renderList = () => {
        return (actionList?.length > 1 ? React.createElement(View, null,
            React.createElement(FlatList, { data: actionList, renderItem: renderItem, horizontal: true, style: { width: '100%' }, showsHorizontalScrollIndicator: false })) :
            React.createElement(TouchableOpacity, { style: [
                    styles.cardStyle,
                    { width: '100%', flex: 1 },
                ], onPress: () => {
                    if (viewAction) {
                        if (actionList[0].type === "REVOCATION") {
                            triggerAction(viewAction);
                        }
                        else {
                            triggerAction({
                                ...viewAction,
                                payload: {
                                    type: actionList[0].type
                                },
                            });
                        }
                    }
                } },
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(Image, { source: {
                            uri: getUrlImage(actionList[0].type, actionList[0]?.title)
                        }, style: actionList[0]?.title?.includes('failed')
                            ? { width: 20, height: 20 }
                            : { width: 32, height: 32 } }),
                    React.createElement(View, { style: { marginLeft: 8 } },
                        React.createElement(Typography, { label: actionList[0]?.title, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Night, fontWeight: '600' }),
                        React.createElement(View, null,
                            React.createElement(Typography, { label: actionList[0]?.subTitle, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B3R })))),
                React.createElement(View, null,
                    React.createElement(View, { style: { marginLeft: 16, justifyContent: 'flex-end' } },
                        React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal })))));
    };
    const renderItem = ({ item }) => {
        return (React.createElement(TouchableOpacity, { style: [
                styles.cardStyle,
                { width: '100%', flex: 1, marginRight: 8, alignContent: 'center', alignItems: 'center', justifyContent: 'center' },
            ], onPress: () => {
                if (viewAction) {
                    if (item.type === "REVOCATION") {
                        triggerAction(viewAction);
                    }
                    else {
                        triggerAction({
                            ...viewAction,
                            payload: {
                                ...viewAction?.payload,
                                type: item?.type
                            },
                        });
                    }
                }
            } },
            React.createElement(Image, { source: {
                    uri: getUrlImage(item?.type, item?.title)
                }, style: item?.title?.includes('failed')
                    ? { width: 20, height: 20 }
                    : { width: 32, height: 32 } }),
            React.createElement(View, { style: { marginLeft: 8 } },
                React.createElement(Typography, { label: item?.title, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Night, fontWeight: '600' }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { label: item?.subTitle, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B3R }))),
            React.createElement(View, { style: { marginLeft: 16 } },
                React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal }))));
    };
    if (isList) {
        return renderList();
    }
    return (React.createElement(View, { style: styles.cardStyle },
        React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(Image, { source: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/rupee_aura.png',
                }, style: styles.rupeeImageStyle }),
            React.createElement(View, { style: { marginLeft: 8 } },
                React.createElement(Typography, { label: 'Unpledge request in progress', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'This may take up to 3-4 business days', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 16 })))),
        React.createElement(TouchableOpacity, { onPress: () => {
                if (viewAction) {
                    triggerAction(viewAction);
                }
            }, style: {
                position: 'absolute',
                right: 0,
                borderRadius: 1000,
                borderColor: '#1434CB',
                paddingHorizontal: 8,
                borderWidth: 1,
                marginRight: 8,
                paddingVertical: 4,
            } },
            React.createElement(Typography, { label: 'View', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100 }))));
};
const styles = StyleSheet.create({
    cardStyle: {
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        borderColor: '#E4E7EC',
        padding: 8,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    rupeeImageStyle: {
        width: 22,
        height: 22,
    },
    rupeeImageStyleDashboard: {
        width: 33,
        height: 33,
    }
});
export default memo(PendingUnpledgeView);
export { PendingUnpledgeView };
